import { render, staticRenderFns } from "./EditDataSynonyms.vue?vue&type=template&id=1ee46b4a&"
import script from "./EditDataSynonyms.vue?vue&type=script&lang=js&"
export * from "./EditDataSynonyms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports